import { useEffect, useReducer, useRef } from "react";
import { getEventsData } from "../../services/board";
import { useLocation, useNavigate } from "react-router-dom";
import { getEventTasks } from "services/event";

const initialArgs = {
  eventFetchedData: {},
  isEventCallApi: true,
  showChatbox: false,
  toast: {
    show: false,
    message: '',
    heading: ''
  },
  openPlanningAnimation: false,
  feteDescriptionLoader: true,
  showInsight: false,
  showReviewSpace: false,
  downloadChart: false,
  chartName: '',
  downloadChartName: '',
  isInsightCallApi: true,
  callFromEmptyReviewSpace: false,  // To go back to fetebuddy window from review space or fete icon click
  brainStormText: null,
  insightEditData: [],
  eventTasks: [],
  bestActionQuery: null,
  bestActionPrompt: null,
  showImageUploader: false,
  updatedFeteImageUrl: null,
  sampleImages: [],
  currentTaskObj: null,
  unsavedChanges: false
};

const reducer = (state: any, action: any) => {
  return { ...state, ...action };
};

const useEventHook = () => {
  const [state, setState] = useReducer(reducer, initialArgs);
  const navigate = useNavigate();
  const location = useLocation();

  const sendButtonRef = useRef<any>(null);

  const resetStateToDefaults = () => {
    setState({ ...initialArgs })
  }

  useEffect(() => {
    if (state.toast.show) {
      setTimeout(() => {
        setState({ ...state, toast: initialArgs.toast })
      }, 5000);
    }
  }, [state.toast])

  useEffect(() => {
    resetStateToDefaults();
  }, [location.pathname]);


  const updateEventCallApiFlag = (flag: boolean) => {
    setState({ ...state, isEventCallApi: flag });
  }

  const getAllTasks = async (id: any) => {
    try {
      const { data } = await getEventTasks(id);
      const tasks: any = [];
      if (data && data?.length > 0) {
        data?.forEach((item: any) => {
          item?.tasks.forEach((task: any) => {
            tasks.push({ _id: task?._id, taskId: task?._id, title: task?.title, is_completed: task?.is_completed, cardTitle: item?.title })
          })
        })
      }
      return tasks;
    } catch (error) {
      console.log('update Event Tasks Err::', error);
    }
  }

  // fetch event data
  const fetchEventData = async (id: string) => {
    try {
      const response = await getEventsData(id);
      const tasks = await getAllTasks(response?.data?._id)
      setState({ ...state, eventFetchedData: response.data, isEventCallApi: false, feteDescriptionLoader: false, eventTasks: tasks });
    } catch (error: any) {
      console.log("Error while fetching events =", error);
      if (error.message === "You are not a part of this event") {
        navigate('/')
      }
    }
  };

  return {
    fetchEventData,
    updateEventCallApiFlag,
    setState,
    sendButtonRef,
    ...state,
  };
};

export default useEventHook;
